import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { PreviewWakeGuard } from './components/PreviewWakeGuard';
import './index.css';
import './sentry'; // Initialize Sentry
import { installChunkReloadGuard } from './utils/chunkReload';

// Reload when a chunk is gone after a deploy, at most once per cooldown
installChunkReloadGuard();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* Inert outside preview builds; on a frozen preview it wakes the api
        before the app mounts. */}
    <PreviewWakeGuard>
      <App />
    </PreviewWakeGuard>
  </React.StrictMode>
);
